import { Component, Fragment } from "react";
import RightPanel from "apps/todo/components/right-panel";
import DatePanel from "apps/todo/components/date-panel";
import TodoList from "apps/todo/components/todo-list";
import TodoDataContainer from "apps/todo/components/todo-data-container";
import moment from "moment";
import { Loading } from "@evertrue/et-components";
import PropTypes from "prop-types";

// eslint-disable-next-line
const TodoDataContainerWithLoading = props => (
  <TodoDataContainer
    {...props}
    render={args => <Fragment>{args.loading ? <Loading /> : props.render(args)}</Fragment>}
  />
);
TodoDataContainerWithLoading.propTypes = {
  render: PropTypes.func,
};

const getToDate = date => {
  return moment(date)
    .endOf("day")
    .valueOf();
};

const getFromDate = date => {
  return moment(date)
    .startOf("day")
    .valueOf();
};

const getUpcomingDate = date => {
  const year = 365 * 24 * 60 * 60 * 1000;
  const date_upcoming = date + year;
  return moment(date_upcoming)
    .startOf("day")
    .valueOf();
};

const TAB_OPTIONS = ["TODAY", "UPCOMING", "UNSCHEDULED"];

class TodoController extends Component {
  state = {
    selected_date: moment().valueOf(),
    selected_tab: TAB_OPTIONS[0],
    isCalendarOpen: false,
  };

  selectedDateChangedTo = date => {
    this.setState({
      selected_date: date,
    });
  };

  tabChangedTo = tab => {
    if (this.state.selected_tab !== tab) {
      this.setState({
        selected_tab: tab,
        selected_date: moment().valueOf(),
      });
    }
  };

  toggleCalendar = () => {
    this.setState(state => {
      return { isCalendarOpen: !state.isCalendarOpen };
    });
  };

  render() {
    return (
      <RightPanel tabChanged={this.tabChangedTo} selectedTab={this.state.selected_tab} tabList={TAB_OPTIONS}>
        {
          {
            [TAB_OPTIONS[0]]: (
              <TodoDataContainerWithLoading
                key={TAB_OPTIONS[0]}
                gte={getFromDate(this.state.selected_date)}
                lte={getToDate(this.state.selected_date)}
                render={({ todos, markComplete, deleteTodo, createTodo, editTodo }) => (
                  <TodoList
                    todos={todos}
                    toDoCheckmarkTappedWithId={markComplete}
                    placeholder="You are all caught up !"
                    deleteTodo={deleteTodo}
                    updateTodo={editTodo}
                    createTodo={createTodo}
                    currentDate={this.state.selected_date}
                    listHeader={
                      <DatePanel
                        currentDate={this.state.selected_date}
                        selectedDateChangedTo={this.selectedDateChangedTo}
                        isCalendarOpen={this.state.isCalendarOpen}
                        toggleCalendar={this.toggleCalendar}
                      />
                    }
                  />
                )}
              />
            ),
            [TAB_OPTIONS[1]]: (
              <TodoDataContainerWithLoading
                key={TAB_OPTIONS[1]}
                gte={getToDate(moment().valueOf())}
                lte={getUpcomingDate(moment().valueOf())}
                onlyIncomplete={true}
                render={({ todos, markComplete, deleteTodo, createTodo, editTodo }) => (
                  <TodoList
                    todos={todos}
                    toDoCheckmarkTappedWithId={markComplete}
                    placeholder="No upcoming To-Dos"
                    deleteTodo={deleteTodo}
                    updateTodo={editTodo}
                    createTodo={createTodo}
                    currentDate={this.state.selected_date}
                    listHeader={<div className="todo--list-info-text">NEXT 10</div>}
                  />
                )}
              />
            ),
            [TAB_OPTIONS[2]]: (
              <TodoDataContainerWithLoading
                key={TAB_OPTIONS[2]}
                gte={null}
                lte={null}
                render={({ todos, markComplete, deleteTodo, createTodo, editTodo }) => (
                  <TodoList
                    todos={todos}
                    toDoCheckmarkTappedWithId={markComplete}
                    placeholder="No un-scheduled To-Dos"
                    deleteTodo={deleteTodo}
                    updateTodo={editTodo}
                    createTodo={createTodo}
                    currentDate={this.state.selected_date}
                    listHeader={<div className="todo--list-info-text">UNSCHEDULED</div>}
                  />
                )}
              />
            ),
          }[this.state.selected_tab]
        }
      </RightPanel>
    );
  }
}

export default TodoController;
